export class Recommendation {
    constructor(public data?: {
        ID?: Number,
        CCClientID?: Number,
        Firstname?: String,
        Lastname?: String,
        Street?: String,
        HomeNumber?: String,
        Settlement?: String,
        PostalCode?: String,
        Email?: String,
        PhoneNumber?: String,
        Mobile?: String,
        WorkStatusID?: Number,
        IncomeID?: Number,
        PolicyStatusID?: Number,
        UserID?: Number,
        Remark?: String,
        PersonalAgreement?: String,
        AppointmentID?: Number,
        PhonebookID?: Number,
        UploadToken?: String,
        UploadTokenExpires?: String
    }) { }
}